<template>
    <p class="offer-comment" v-if="visible">Komentarz: {{comment}}</p>
</template>

<script>
    export default {
        name:  "measurementComment",
        data() {
            return {
                comment: '',
                visible: false
            }
        },
        mounted() {
            if(this.$store.state.activeFun.data.comment_enabled) {
                if(this.$store.state.activeFun.data.comment) {
                    this.visible = true;
                    this.comment = this.$store.state.activeFun.data.comment;
                } else this.visible = false;
            } else this.visible = false;
        }
    }
</script>